import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import { HardHat, PaintRoller, Wrench } from 'lucide-react'

interface ServiceIconProps {
    slug: string | null | undefined
    className?: string
}

// Icons follow the service slug; a new service added in the CMS gets the hard hat.
const icons: Record<string, LucideIcon> = {
    'gradjevinski-radovi': HardHat,
    'adaptacije-i-renoviranja': PaintRoller,
    'instalacioni-radovi': Wrench
}

export const ServiceIcon: FC<ServiceIconProps> = ({ slug, className }): ReactNode => {
    const Icon = (slug && icons[slug]) || HardHat

    return <Icon className={className} aria-hidden='true' strokeWidth={1.5} />
}
